"use strict";
import Common from "./Common";

var that;

export default class Button extends p3.Button {
    /**
     * @param states
     * @param scope
     * @param audioType
     */
    constructor(states, scope, audioType) {

        super(states);
        that = scope;
        this.type = audioType || "fwd";

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._normal = new PIXI.Sprite(states.normal || PIXI.Texture.EMPTY);
        this._normal.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._normal);
        this._normal.visible = false;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._over = new PIXI.Sprite(states.over || PIXI.Texture.EMPTY);
        this._over.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._over);
        this._over.visible = false;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._down = new PIXI.Sprite(states.down || PIXI.Texture.EMPTY);
        this._down.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._down);
        this._down.visible = false;
    }

    onMouseOver() {
        if (!that.isMute) that.audio.playSound("sfx_btn_rollover_00");
        super.onMouseOver();
    }

    onMouseDown() {
        if (!that.isMute) {
            that.audio.playSound("sfx_btn_press_00");
        }
        super.onMouseDown();
    }

    onMouseOut() {
        super.onMouseOut();
    }

    get enabled() {
        return this._enabled;
    }

    set enabled(bool) {
        this._enabled = bool;
    }
}